
<div class="page-content-inner" fxFlex fxLayoutAlign='center'>
  <div class="content mat-typography">
    <div fxLayoutAlign="space-between">
      <div fxLayout="row" fxAlign="start">
        <div fxLayout="column">
          <gz-page-title [title]="simulation.name || simulation.groupId" icon="computer"></gz-page-title>
          <h4>
            By <a routerLink="/{{simulation?.owner}}">{{simulation?.owner}}</a>
          </h4>
        </div>
      </div>
    </div>

    <div fxLayout="row">
      <div class="status" fxLayout="row" fxLayoutAlign="left center" fxLayoutGap="20px" fxFill>
          <div class="statusTitle">{{simulation.status}}</div>

          <div>
            <span class="statusTitle" *ngIf="simulation.errorStatus">Error</span>
            <span class="statusTitle" *ngIf="simulation.errorStatus">{{simulation.errorStatus}}</span>

            <span class="statusTitle" *ngIf="!simulation.errorStatus"></span>
            <span class="statusTitle" *ngIf="!simulation.errorStatus">No errors</span>
          </div>

          <div fxLayout="row" fxLayoutGap="20px" *ngIf="simulation.status == 'Running'">
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between">
            <div class="statusTitle">Real Time</div>
            <div class="statusData" *ngIf="realTime">{{realTime | gzDuration}}</div>
          </div>

          <div fxLayout="row"  fxLayoutGap="10px" fxLayoutAlign="space-between">
            <div class="statusTitle">Simulation Time</div>
            <div class="statusData" *ngIf="simTime">{{simTime | gzDuration}}</div>
          </div>

          <div fxLayout="row" fxLayoutGap="10px"  fxLayoutAlign="space-between">
            <div class="statusTitle">Real Time Factor</div>
            <div class="statusData" *ngIf="realTimeFactor">{{realTimeFactor*100 | number: '1.2-2'}}%</div>
          </div>
          </div>

      </div>
    </div>

    <div fxLayout="row">
      <div class="visualizer" fxFill>
        <div class="outer" #fullScreen>

          <a class="follow-button" *ngIf="following" mat-icon-button (click)="follow(null)" title="Stop following">Stop following</a>

          <!--
          <div class="controls" *ngIf="(sceneMgr.status$ | async) === 'Ready'">
            <a mat-icon-button (click)="toggleLights()" title="Toggle lights"><mat-icon>highlight</mat-icon></a>
            <a mat-icon-button (click)="snapshot()" title="Take a snapshot"><mat-icon>camera_alt</mat-icon></a>
            <a mat-icon-button (click)="resetView()" title="Reset view"><mat-icon>home</mat-icon></a>
            <a mat-icon-button (click)="toggleFullscreen()" title="Full screen"><mat-icon>fullscreen</mat-icon></a>
          </div>
          -->

          <div class="inner" fxLayoutAlign="center center">
            <div fxLayout="row" fxLayoutAlign="center center">
              <span *ngIf="!simulation.isRunning()"
                    class="mat-typography font-x-large">
                Visualization only available while the simulation is running.
              </span>

              <div *ngIf="simulation.isRunning()" id="gz-scene" (window:resize)="resize()"></div>
              <div fxLayout="column" class="gz3d-side-panel" *ngIf="models.length > 0">
                <h2>Entities</h2>
                <mat-list class="entity-list">
                  <div mat-subheader>Models</div>

                  <mat-list-item *ngFor="let model of models" [matMenuTriggerFor]="menu">{{model['name']}}
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="select(model)">Select</button>
                      <button mat-menu-item (click)="moveTo(model)">Move to</button>
                      <button mat-menu-item (click)="follow(model)">Follow</button>
                    </mat-menu>
                  </mat-list-item>

                  <div mat-subheader>Sensors</div>

                  <mat-selection-list [multiple]="true" (selectionChange)="handleSensorSubscription($event)">
                    <mat-list-option *ngFor="let sensor of sensorList"
                                     [checkboxPosition]="'before'"
                                     [value]="sensor"
                                     [title]="sensor">
                      <span class="sensor-topic">&lrm;{{ sensor }}</span>
                    </mat-list-option>
                  </mat-selection-list>
                </mat-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="image-streams" class="image-container">
    </div>

    <!-- <gz-simulation-actions [simulation]=simulation></gz-simulation-actions> -->
  </div>
</div>
